import React from 'react';
import { Route, withRouter, Redirect, Switch } from 'react-router-dom';
import { get } from 'lodash';
import axios from 'axios';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import ProgressTracker from '../../containers/ProgressTracker';
import Dados from './Dados';
import Fonte from './Fonte';
import ReferenciaBibliografica from './ReferenciaBibliografica';
import MatrizReferencia from './MatrizReferencia';
import Conteudo from './Conteudo';
import Pendencias from './Pendencias';
import DetectorPlagio from '../revisoes/DetectorPlagio';
import Confirmar from './Confirmar';
import DadosGerais from '../../containers/DadosGerais';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';

class Itens extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      fetchingItem: true,
      isDisabled: false,
      tipoId: this.get_categoria_id()
    };
  }

  breadCrumb = 'Novo recurso'
  breadCrumb2 = 'Recursos';
  breadCrumb3 = 'Recurso';
  breadCrumb4 = 'recurso pedagógico';

  componentDidMount() {
    this.fetchItem();
  }

  get id() {
    return this.props.match.params.id;
  }

  get_categoria_id() {
    const url = window.location.href;
    const parts = url.split('/');
    return parts.pop();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const changedStep = prevProps.location.pathname !== location.pathname;
    if (changedStep) {
      this.fetchItem();
    }
  }

  get canViewPlagiusDetector() {
    // Habilitado temporariamente somente para super usuários
    const permissions = get(this.props, 'permissions') || {};
    // eslint-disable-next-line
    return permissions.__all__;
    // return permissions.__all__ || permissions['itens.view_plagio'];
  }

  getDetails() {
    return [
      {
        col: '',
        title: 'Tipo',
        text: 'Discursivo'
      }
    ];
  }

  getSteps() {
    const id = get(this.props, 'match.params.id');
    const {
      location: { pathname }
    } = this.props;
    const { item, tipoId } = this.state;
    const steps = [
      {
        id: 1,
        title: `Informações sobre o ${this.breadCrumb4}`,
        path: '/itens/:id/dados',
        link: `/itens/${id}/dados`,
        active: pathname === `/itens/${id}/dados`,
        done: this.stepDone(pathname),
        component: () => <Dados isDisabled={this.state.isDisabled} breadCrumb={this.breadCrumb4} tipoId={tipoId} />,

        disabled: false
      },
      {
        id: 2,
        title: 'Matriz de Referência',
        path: '/itens/:id/matrizes-referencia',
        link: `/itens/${id}/matrizes-referencia`,
        active: pathname === `/itens/${id}/matrizes-referencia`,
        done: this.stepDone(pathname),
        component: () => (
          <MatrizReferencia item={item} isDisabled={this.state.isDisabled} />
        ),
        disabled: id === 'new'
      },
      {
        id: 3,
        title: 'Referência bibliográfica',
        path: '/itens/:id/referencias-bibliograficas',
        link: `/itens/${id}/referencias-bibliograficas`,
        active: pathname === `/itens/${id}/referencias-bibliograficas`,
        done: this.stepDone(pathname),
        component: () => (
          <ReferenciaBibliografica isDisabled={this.state.isDisabled} />
        ),
        disabled: id === 'new'
      },
      {
        id: 4,
        title: 'Conteúdo',
        path: '/itens/:id/conteudo',
        link: `/itens/${id}/conteudo`,
        active: pathname === `/itens/${id}/conteudo`,
        done: this.stepDone(pathname),
        component: () => <Conteudo isDisabled={this.state.isDisabled} />,
        disabled: id === 'new'
      },
      {
        id: 5,
        title: 'Fonte',
        path: '/itens/:id/fonte',
        link: `/itens/${id}/fonte`,
        active: pathname === `/itens/${id}/fonte`,
        done: this.stepDone(pathname),
        component: () => <Fonte isDisabled={this.state.isDisabled} />,

        disabled: id === 'new'
      },
      {
        id: 6,
        title: `Checagem do conteúdo do ${this.breadCrumb4}`,
        path: '/itens/:id/pendencias',
        link: `/itens/${id}/pendencias`,
        active: pathname === `/itens/${id}/pendencias`,
        done: false,
        component: () => <Pendencias breadCrumb={this.breadCrumb4} />,
        disabled: id === 'new'
      },
      {
        id: 7,
        title: 'Detector de plágio',
        path: '/itens/:id/plagio',
        link: `/itens/${id}/plagio`,
        active: pathname === `/itens/${id}/plagio`,
        done: false,
        component: () => <DetectorPlagio item={item.id} />,
        disabled: id === 'new',
        hidden: !this.canViewPlagiusDetector
      },
      {
        id: 8,
        title: 'Revisão',
        path: '/itens/:id/confirmar',
        link: `/itens/${id}/confirmar`,
        active: pathname === `/itens/${id}/confirmar`,
        done: this.stepDone(pathname),
        component: () => <Confirmar tipoId={tipoId} />,
        disabled: id === 'new'
      }
    ];

    return steps.filter((d) => !d.hidden);
  }

  getCurrentPath() {
    const id = get(this.props, 'match.params.id');
    return id === 'new'
      ? this.breadCrumb
      : `${this.breadCrumb} ${id}`;
  }

  stepDone() {
    return false;
  }

  fetchItem() {
    if (this.id !== 'new') {
      axios
        .get(`${API_HOST}/itens/item/${this.id}`)
        .then((response) => {
          this.setState({
            item: response.data,
            fetchingItem: false
          });
          this.fetchMe(response.data);
        })
        .catch(() => {
          this.props.history.push('/itens/404');
        });
    } else {
      this.setState({ fetchingItem: false });
    }
  }

  fetchMe(item) {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({
          isDisabled:
            (!!item.pa || !!item.pb || !!item.pc) ||
            (response.data.logged_group.includes('ADMINISTRADOR') ||
              response.data.logged_group.includes('ELABORADORSOMOS')
              ? false
              : response.data.id == item.criado_por_ids
                ? false
                : true)
        });
      })
      .catch((response) => console.log(response.error));
  }
  render() {
    const { match } = this.props
    const { tipoId } = this.state
    const pathList = [
      {
        label: this.breadCrumb2,
        link: '/itens'
      }
    ];

    switch (tipoId) {
      case '1':
        this.breadCrumb = match.params.id === 'new' ? 'Novo Item' : 'Item';
        this.breadCrumb2 = 'Banco de Itens';
        this.breadCrumb3 = 'Item';
        this.breadCrumb4 = 'item';
        break;
      case '2':
        this.breadCrumb = match.params.id === 'new' ? 'Nova recurso' : 'Recurso';
        this.breadCrumb2 = 'Recursos Pedagógicos';
        this.breadCrumb3 = 'Recurso';
        this.breadCrumb4 = 'recurso pedagógico';
        break;
      default:
        this.breadCrumb = 'Novo Item'
        this.breadCrumb2 = 'Banco de Itens';
        this.breadCrumb3 = 'Item';
        this.breadCrumb4 = 'item';
        break;
    }
    const steps = this.getSteps();
    const id = get(this.props, 'match.params.id');
    const { item, fetchingItem } = this.state;

    const currentStep = this.props.location.pathname;

    if (fetchingItem) {
      return (
        <div className="p-5">
          <Loading />
        </div>
      );
    }

    return (
      <div>
        <NavBreadCrumb
          pathList={pathList}
          currentPath={this.getCurrentPath()}
        />
        <div className="container">
          <div className="row pb-4">
            <div className="col-3">
              <ProgressTracker steps={steps} />
            </div>
            <div className="col-sm-9">
              {/* {currentStep !== `/itens/${id}/dados` && (
                <DadosGerais {...item} loading={fetchingItem} />
              )} */}
              <Switch>
                {steps.map((step, index) => (
                  <Route
                    key={step.id}
                    path={step.path}
                    render={() =>
                      step.disabled ? (
                        <Redirect to="/itens/new/dados" />
                      ) : (
                        <step.component step={index} />
                      )
                    }
                  />
                ))}
                <Route
                  path="/itens/new"
                  render={() => <Redirect to="/itens/new/dados" />}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Itens);
